<template>
  <div id="dashboardProjetos" class="column resumo-subsidio">
    <div v-show="deveExibirDados" class="container container_com-fundo container_com-margem">
      <loading :ativo="loading" />
      <alerta :tipo="tipoDeAlerta" :texto="mensagemDeAlerta" />
      <div class="boxs">
        <div v-for="status of dadosPorStatus" :class="['boxs-item', status.classeCss]">
          <div class="informacoes">
            <h2>{{ status.nome }} </h2>
            <div> <span class="valor-saldo"> {{ status.quantidade }} </span> {{ status.tipoDoDado }}</div>
            <div class="percentual-progress"> <strong>{{ status.valorFormatado }} - {{ status.valorPercentual
                }}</strong>
              <span></span>% do valor total
            </div>
          </div>
        </div>
      </div>

      <div class="progress progress-saldo-total">
        <div v-for="status of dadosPorStatus" v-if="status.nome != 'Não utilizado'"
          :class="['progress-bar', status.classeCss]" :style="{ width: `${status.valorPercentual}%` }"
          role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100">
          <div class="percentual">
            {{ valorCabeNaBarra(status.valorPercentual) ? status.valorPercentual + '%' : '' }}
          </div>
        </div>
      </div>
      <div class="grafico-familias">
        <div class="icone-familia">
          <i class="fa fa-users" aria-hidden="true"></i>
          <h2>Subsídio por família</h2>
        </div>
        <div class="area-graficos">
          <div v-if="!projetoEhBonusMoradia" class="expectativa-familias-a-atender">
            <div class="legenda">
              <strong>Expectativa em atender mais<span class="quantidade">{{ quantidadeDeFamiliasQueAindaFaltamAtender
                  }}
                </span> famílias</strong>
              <span class="figura nao-utilizado"></span>
            </div>
            <p class="texto">
              baseado no saldo <strong>não utilizado</strong> e na média de <br>valores dos subsídios atualmente
              estimado
              em
              </br>
              <strong>{{ valorMedioDoSubsidio }}</strong>
            </p>
          </div>
          <div class="grafico quantidade-familias-atendidas">
            <canvas id="chart" width="200" height="200"></canvas>
          </div>
          <div class="legenda">
            <ul>
              <li v-for="(legenda) of dadosDaLegenda.filter(legenda => legenda.deveMostrarNaLista)">
                <span class="figura" :style="{ background: `${legenda.cor}` }"></span>
                <span class="titulo"> <strong>{{ legenda.quantidade }} </strong> {{ legenda.descricao }} </span>
              </li>
              <li class="total-atendido">
                Total de <span>{{ totalDeFamiliasAtendidas }}</span> famílias já atendidas
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="print">
        <div class="printar-data"> Impresso em {{ new Date().toLocaleDateString('pt-BR') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import Chart from "chart-js";
import Loading from "../shared/Loading";
import Alerta from '../shared/Alerta';

export default {
  props: {
    dadosDoFiltro: {
      type: Object,
      required: true,
      default: () => ({
        idProjeto: null,
        idCidade: null,
        projetoNome: '',
        projetoEhMcmvCidades: false
      })
    }
  },
  components: { Loading, Alerta },
  name: "dashboardProjetos",
  data() {
    return {
      tipoDeAlerta: null,
      mensagemDeAlerta: null,
      valorTotalDoProjeto: null,
      valorMedioDoSubsidio: null,
      loading: false,
      projetoEhBonusMoradia: false,
      grafico: null,
      dadosPorStatus: [],
      dadosDaLegenda: [],
      totalDeFamiliasAtendidas: null,
      quantidadeDeFamiliasQueAindaFaltamAtender: null,
      statusPorFamilia: [
        "famílias já receberam o subsídio",
        "famílias ainda estão em reservado",
        "novas famílias solicitaram",
        "a serem atendidas",
      ],
    };
  },
  computed: {
    deveExibirDados() {
      const { idProjeto, projetoEhMcmvCidades } = this.dadosDoFiltro;
      const projetoNaoEhVazio = idProjeto !== null;
      return this.dadosPorStatus.length > 0 && !projetoEhMcmvCidades && projetoNaoEhVazio;
    },
  },
  watch: {
    dadosDoFiltro(dadosDoFiltro) {
      this.dadosDoFiltro = dadosDoFiltro;
      this.verificarEObterDados();
    }
  },
  methods: {
    verificarEObterDados() {
      if (!this.dadosDoFiltro.projetoEhMcmvCidades) {
        if (this.dadosDoFiltro.idProjeto) { this.obterDados(); }
        else {
          this.exibirAlerta("Informe o projeto")
          return;
        }
      }
    },
    obterDados() {
      let url = "/Dashboard/ObterDados";
      if (!this.dadosDoFiltro.idProjeto) {
        this.exibirAlerta("Informe o projeto")
        return;
      }
      const params = { projetoId: this.dadosDoFiltro.idProjeto };
      if (this.dadosDoFiltro.idCidade) {
        params.cidadeId = this.dadosDoFiltro.idCidade;
      }

      this.loading = true;
      this.$api
        .post(url, params)
        .then((response) => {
          const dados = response.data;
          this.projetoEhBonusMoradia = dados.ProjetoEhBonusMoradia;
          this.valorTotalDoProjeto = this.$moeda.formatar(dados.ValorTotalDoProjeto);
          this.valorMedioDoSubsidio = this.$moeda.formatar(dados.ValorMedioDasSolicitacoes);
          this.dadosPorStatus = this.gerarDados(dados.ResumosPorStatus, dados.ProjetoEhBonusMoradia);
          this.totalDeFamiliasAtendidas = dados.ProjetoEhBonusMoradia 
            ? this.obterQuantiDadeDeSolicitacoesLiquidadas(dados.ValoresLiquidados) 
            : dados.QuantidadeTotalDeSolicitacoes;
            
          this.quantidadeDeFamiliasQueAindaFaltamAtender = dados.QuantidadeTotalDeSolicitacoes > 0 
            ? dados.QuantidadeTotalDeSolicitacoesEsperadas - dados.QuantidadeTotalDeSolicitacoes 
            : 0;
          this.loading = false;
          const dadosParaGrafico = this.gerarDadosParaGrafico(dados)
          this.$emit('atualizarValorTotal', this.valorTotalDoProjeto);

          this.gerarGrafico(dadosParaGrafico);
        });
    },
    obterQuantiDadeDeSolicitacoesLiquidadas(valores) {
      const valoresLiquidados = valores.filter(v => v.Descricao !== 'Não utilizado')
        .map(v => v.Quantidade);

      return valoresLiquidados.reduce((item, itemCorrente) => {

        return item + itemCorrente;
      }, 0);
    },
    gerarDadosParaGrafico(dadosDoGrafico) {
      this.dadosDaLegenda = [];
      const dados = dadosDoGrafico.ProjetoEhBonusMoradia ?
        dadosDoGrafico.ValoresLiquidados.filter(v => v.Descricao !== 'Não utilizado') : 
        dadosDoGrafico.ResumosPorStatus;

      const valores = [];
      const cores = [];
      const labels = dadosDoGrafico.ProjetoEhBonusMoradia 
        ? dados.map(x => x.Descricao) 
        : this.statusPorFamilia;

      dados.forEach((dado, indice) => {
        let cor = dadosDoGrafico.ProjetoEhBonusMoradia 
          ? this.obterCorPorValor(dado.Descricao)
          : this.obterCorPorStatus(dado.Descricao);
          
        valores.push(dado.QuantidadePercentual);
        cores.push(cor);

        this.dadosDaLegenda.push({
          valor: dado.QuantidadePercentual,
          cor: cor,
          quantidade: dado.Quantidade,
          deveMostrarNaLista: dado.Descricao !== "Não utilizado",
          descricao: dadosDoGrafico.ProjetoEhBonusMoradia 
            ? ` famílias já receberam o subsídio no valor de ${dado.Descricao}` 
            : this.statusPorFamilia[indice]
        });
      });

      let dataset = {
        label: "Subsídio por família",
        data: valores,
        backgroundColor: cores,
      };

      return {
        dataset: dataset,
        labels: labels
      };
    },
    obterCorPorValor(descricao) {
      const cores = {
        "R$ 25.000,00": "rgba(97, 21, 0, 1)",
        "R$ 17.000,00": "rgba(148, 32, 0, 1)",
        "R$ 15.000,00": "rgba(199, 63, 25, 1)",
        "R$ 13.000,00": "rgba(255, 139, 107, 1)",
        "R$ 8.000,00": "rgba(255, 173, 150, 1)",
        "R$ 6.000,00": "rgba(255, 206, 193, 1)",
        "Não utilizado": "rgba(85, 85, 85, 0.50)"
      };
      let corPorvalor = cores[descricao];

      if (!corPorvalor) {
        const x = Math.floor(Math.random() * 256);
        const y = Math.floor(Math.random() * 256);
        const z = Math.floor(Math.random() * 256);
        corPorvalor = `rgba(${x}, ${y}, ${z}, 1)`
      }
      return corPorvalor;
    },
    gerarDados(dadosPorStatus, projetoEhBonusMoradia) {
      const dados = [];
      dadosPorStatus.forEach((status) => {
        const descricao = status.Descricao;
        const informacoesPorStatus = { nome: descricao };

        informacoesPorStatus.classeCss = descricao
          .replace("ã", "a")
          .replace("í", "i")
          .split(" ")
          .join("-")
          .toLowerCase();
        informacoesPorStatus.valor = status.Valor;
        informacoesPorStatus.valorFormatado = this.$moeda.formatar(status.Valor);
        informacoesPorStatus.valorPercentual = status.ValorPercentual;
        informacoesPorStatus.quantidade = projetoEhBonusMoradia && status.Descricao === "Não utilizado" ?
          status.TotalDeCotas :
          status.Quantidade;
        informacoesPorStatus.quantidadePercentual = status.QuantidadePercentual;
        informacoesPorStatus.tipoDoDado = !projetoEhBonusMoradia ? 'imóveis' : 'cotas'

        dados.push(informacoesPorStatus);
      });

      return dados;
    },
    obterCorPorStatus(status) {
      const cores = {
        "Subsídio liquidado": "rgba(75, 192, 192, 1)",
        "Reservado": "rgba(222, 166, 16, 1)",
        "Solicitado": "rgba(54, 162, 235, 1)",
        "Não utilizado": "rgba(85, 85, 85, 0.50)",
      };

      return cores[status];
    },
    valorCabeNaBarra(valor) {
      return valor > 2;
    },
    exibirAlerta(mensagem) {
      this.tipoDeAlerta = "atencao";
      this.mensagemDeAlerta = mensagem;
    },
    gerarGrafico(dadosDoGrafico) {
      if (!this.grafico) {
        this.grafico = this.criarGrafico(dadosDoGrafico.labels, dadosDoGrafico.dataset);
      } else {
        this.atualizarGrafico(dadosDoGrafico.dataset);
      }
    },
    criarGrafico(labels, dataset) {
      const chart = document.getElementById("chart").getContext("2d");
      return new Chart(chart, {
        type: "doughnut",
        data: {
          labels,
          datasets: [dataset],
        },
        options: {
          cutoutPercentage: 60,
          responsive: true,
          legend: {
            position: "right",
            display: false,
            fullWidth: false,
          },
          animation: {
            animateScale: true,
            animateRotate: true,
          },
          tooltips: {
            callbacks: {
              label(tooltipItem, data) {
                const value =
                  data.datasets[tooltipItem.datasetIndex].data[
                  tooltipItem.index
                  ];
                return ` ${value}%`;
              },
            },
          },
        },
      });
    },
    atualizarGrafico(dataset) {
      this.grafico.data.datasets.pop();
      this.grafico.data.datasets.push(dataset);
      this.grafico.update();
    },
  },
};
</script>



// WEBPACK FOOTER //
// DashboardProjetos.vue?5dd88a8c